import { GlobalServices } from '../../../services/global.service';
import { ssApiService } from '../../../services/ss-api.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MemberProfile } from 'app/models/domain/member.profile';
import { CreditCardResponse } from 'app/models/ss-api/responses/credit.card.response';
import { HttpError } from 'app/models/errors/HttpError';
import { DialogService } from 'primeng/dynamicdialog';
import { AddGISDialogComponent } from 'app/dialogs/add-gis/add-gis-dialog.component';
import { SelectItem } from 'primeng/api';
import { GISBundleResponseArray } from 'app/models/ss-api/responses/gis.bundle.response';
import { DashboardProductsResponse, IDashboardProductsResponse } from 'app/models/ss-api/responses/dashboard.products.response';
import { DashboardLicenseResponse, LicenseStatus } from 'app/models/ss-api/responses/dashboard.license.response';
import { PublicOrderProductsResponseArray } from 'app/models/ss-api/responses/public.order.products.response';
import * as moment from 'moment';
import { ReactivateLicenseDialogComponent } from 'app/dialogs/reactivate-license/reactivate-license-dialog.component';
import { AddProductDialogComponent, IAddProductDialogModel } from 'app/dialogs/add-product/add-product-dialog.component';
import { TrainingEvent } from 'app/models/domain/training.event';
import { TrainingClass } from 'app/models/domain/training.class';
import { MemberDesignerLicenseBasicsResponseArray } from 'app/models/ss-api/responses/member.designers.licenses.basics.response';
import { TrainingCalendarRequest } from 'app/models/ss-api/requests/training.calendar.request';
import { MemberTypes } from 'app/models/ss-api/responses/login.response';
import { MembershipsNewComponent } from '../memberships-new/memberships-new.component';

class MemberLicenseItem {
  Member: DashboardProductsResponse;
  License: DashboardLicenseResponse;
}

class CalendarEvent {
  title: string;
  start: Date;
  end: Date;
  extendedProps: {
    event: TrainingEvent
  };
}

@Component({
  selector: 'account-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss'],
  providers: [DialogService]
})

export class OverviewComponent implements OnInit {
  showChangeEmailModal: boolean;
  showChangePasswordModal: boolean;
  showChangePhoneModal: boolean;
  showUpdateCompanyInfoModal: boolean;
  showAddPaymentModal: boolean;
  showGISCreditChooseModal: boolean;

  memberProfile: MemberProfile;
  public defaultCard: CreditCardResponse = new CreditCardResponse();
  isBusy: boolean;

  // gis
  CreditCards: SelectItem[];

  // shared gis
  GISSharedBundle: GISBundleResponseArray;

  // individual gis
  GISIndividualBundle: GISBundleResponseArray;

  // products
  PublicOrderProducts: PublicOrderProductsResponseArray;

  // public
  Products: Array<DashboardProductsResponse> = new Array<DashboardProductsResponse>();
  ProductsExpanded: MemberLicenseItem[] = [];
  onlyPastDueProduct: MemberLicenseItem;

  IsTOS: boolean = false;
  IsDispute: boolean = false;
  HasCancelled: boolean = false;

  HasPastDuePayments: boolean = false;

  hasLicenseOnHold: boolean = false;
  hasLicenseScheduledToHold: boolean = false;
  heldLicense: DashboardLicenseResponse = null;
  MyProducts: MemberDesignerLicenseBasicsResponseArray;
  nextLiveTrainingEvent: any;

  showDesignerProfileBanner: boolean = true;
  isNoLicense: boolean = false;
  showThankyouModal: boolean = this.router.getCurrentNavigation()?.extras?.state?.showThankyouModal;
  @ViewChild('membershipsNew', { static: false }) membershipsNew: MembershipsNewComponent;

  get isDesigner(): boolean {
    return (this.gb.MemberType == MemberTypes.Designer);
  }

  constructor(
    private dialogService: DialogService, private router: Router,
    private route: ActivatedRoute, private api: ssApiService, public gb: GlobalServices
  ) { }

  async ngOnInit() {
    this.gb.SetPageTitle("My Profile");
    this.getMemberProfile();
    this.getCards();
    this.loadEvents();

    try {
      await this.RefreshProducts();
    } catch (e) {

    }
  }

  showPayInvoice() {
    if (!this.isDesigner)
      this.membershipsNew.showPayInvoiceDialog(this.onlyPastDueProduct.License)
  }

  getMemberProfile() {
    this.isBusy = true;
    let disposable = this.api.MemberProfile().subscribe(result => {
      disposable.unsubscribe();
      this.memberProfile = result.Data;
      this.isBusy = false;
    }, error => {
      disposable.unsubscribe();
      this.isBusy = false;
    });

  }

  getCards(): void {
    let request = this.api.CreditCardGetAll()
      .subscribe(response => {
        request.unsubscribe();

        if (!response.Result)
          return; // error

        if (response.Data.length == 0)
          return;

        const cards = response.Data;

        // find default card
        let index = cards.findIndex(x => x.IsDefault == true);

        if (index == -1)
          this.defaultCard = cards[0];
        else
          // set default card
          this.defaultCard = cards[index];
      },
        (error: HttpError) => {
          request.unsubscribe();
        }
      );
  }

  openEmailChange() {
    window.open('https://www.structurestudios.com/help/kb-tickets/new', '_blank');
    this.showChangeEmailModal = false;
  }

  public getPhoneInputValue(v: string): string {
    if (!v) {
      return '';
    }

    // trim '-' dashes
    v = v.replace(/-/g, '');

    v = v.replace(/[^\d]/g, "");

    // trim string to 15 characters
    if (v.length > 10) {
      if (v.length > 15) {
        v = v.substr(0, 15);
      }
      return '   +' + v;
    }


    // new array to hold sections of the License Key
    let numbers = [];

    // create set of characters from first 5 characters
    numbers.push(v.substr(0, 3));

    // try for next 5
    if (v.substr(3, 3) !== "")
      numbers.push(v.substr(3, 3));

    // and last set of 5
    if (v.substr(6, 10) != "")
      numbers.push(v.substr(6, 4));

    if (v.substr(10, 15) != "")
      numbers.push(v.substr(10, 5));

    // add '-' dashes back to formated string
    let newValue = numbers[0];

    //if( newValue.length == 3 ) {

    //}

    if (numbers.length > 1) {
      newValue = '(' + newValue + ') ';
      newValue += numbers[1];
    }


    if (numbers.length > 2)
      newValue += '-' + numbers[2];

    // if (numbers.length > 3 )
    // 	newValue += '-' + numbers[3];

    return newValue;
  }

  openGisCredits(isTeam: boolean) {
    if (isTeam) {
      this.showAddSharedGISDialog();
    } else {
      this.showAddGISDialog('');
    }
  }

  onAddCredits() {
    if (this.isDesigner) {
      this.showAddGISDialog('');
    } else {
      this.showGISCreditChooseModal = true
    }
  }

  PopulateProducts(products: IDashboardProductsResponse) {

    // reset
    this.Products = new Array<DashboardProductsResponse>();

    // add the member or designer (root)
    this.Products.push(products);

    this.IsTOS = products.IsTOS;
    this.IsDispute = products.IsDispute;

    // in case we have designers
    if (products.Desginers != undefined)
      products.Desginers.forEach(x => {
        if (this.IsTOS) {
          x.IsTOS = true;
        }
        if (this.IsDispute) {
          x.IsDispute = true;
        }
        this.Products.push(x);
      });

    this.ProductsExpanded = [];
    this.Products.forEach(item => {
      if (item.Licenses) {
        item.Licenses.forEach(license => {
          let newItem = new MemberLicenseItem;
          newItem.Member = item;
          newItem.License = license;

          this.ProductsExpanded.push(newItem);
        });
      }


    });

    if (this.Products[0]) {
      this.Products.forEach((product) => {
        product.Licenses.forEach(function (license) {
          if ((license.Status == LicenseStatus.Cancelled || license.Status == LicenseStatus.Terminated || license.Status == LicenseStatus.CancelledOpen) && !license.IsGrace) {
            this.HasCancelled = true;
          }
        }, this);
      });
    }

    this.ProductsExpanded = this.SortByStatus(this.ProductsExpanded);

    console.log("ProductsExpanded : ", this.ProductsExpanded);

    this.UpdateHasPastDuePayments(this.ProductsExpanded);

    let productID = localStorage.getItem('cartProductID');
    let billingCycle = localStorage.getItem('cartBillingCycle');

    if (productID && billingCycle) {
      this.showAddDialog();
    }

  }

  CheckForHeldLicense() {
    this.ProductsExpanded.forEach(x => {
      if (x.License.IsOnHold) {
        this.hasLicenseOnHold = true;
        this.heldLicense = x.License;
      }

      if (x.License.IsScheduledHold) {
        this.hasLicenseScheduledToHold = true;
        this.heldLicense = x.License;
      }
    });
  }

  async RefreshProducts(): Promise<DashboardProductsResponse> {

    this.isBusy = true;
    this.HasCancelled = false;

    let productsVariable: DashboardProductsResponse;

    await this.api.ProductsMyProducts().toPromise().then(response => {

      if (!response.Result) {
        this.isBusy = false;
        throw response.Message;
      }

      console.log(response.Data);
      productsVariable = response.Data;
      this.PopulateProducts(response.Data);
      this.CheckForHeldLicense();
      this.isBusy = false;

    }).catch(error => {
      this.isBusy = false;
      throw error;
    });

    return productsVariable;

  }


  private RefreshPublicOrderProducts(): Promise<any> {

    if (this.PublicOrderProducts != undefined && this.PublicOrderProducts.length > 0)
      // we already have propducts
      return new Promise<any>((resolve, reject) => { resolve(this.PublicOrderProducts); });


    // get all products
    return this.api.ProductsOrderProducts()
      .toPromise()
      .then(response => {

        if (!response.Result)
          return; // error

        if (response.Data.length == 0)
          return; // error

        // save
        this.PublicOrderProducts = response.Data;

        return response;
      });
  }


  showAddDialog() {

    this.isBusy = true;

    // 1st get credit cards
    this.GetCreditCards()
      .then((response) => {

        // 2d refresh products
        this.RefreshPublicOrderProducts()
          .then((response) => {
            this.GetCancelledLicense().then((license) => {
              if (this.HasCancelled && license) {
                const ref = this.dialogService.open(ReactivateLicenseDialogComponent, {
                  data: {
                    title: '',
                    License: license,
                    CreditCards: this.CreditCards,
                    CameFromAdd: true,
                    Products: this.PublicOrderProducts,
                    memberProfile: this.memberProfile
                  },
                  showHeader: false,
                  modal: false,
                  maskStyleClass: 'opened',
                  draggable: true,
                  keepInViewport: true
                });
                ref.onClose.subscribe(() => {
                  this.RefreshProducts();
                });
              } else {
                // show add dialog

                let data: IAddProductDialogModel = {
                  title: '',
                  subTitle: '',
                  CreditCards: this.CreditCards,
                  Products: this.PublicOrderProducts,
                  SelectedCreditCard: 0,
                  memberProfile: this.memberProfile
                }
                const ref = this.dialogService.open(AddProductDialogComponent, {
                  data,
                  modal: false,
                  maskStyleClass: 'opened',
                  draggable: true,
                  keepInViewport: true
                });
                ref.onClose.subscribe(() => {
                  this.RefreshProducts();
                });
              }

              this.isBusy = false;
            }).catch(error => {
            });
          })
          .catch((error: HttpError) => {
            this.isBusy = false;
          });

      })
      .catch((error: HttpError) => {
        this.isBusy = false;
      });

  }

  showAddSharedGISDialog() {

    this.isBusy = true;

    // 1st get credit cards
    this.GetCreditCards()
      .then((response) =>

        // 2d get gis shared bundle
        this.GetGISSharedBundle()
          .then((response) => {

            // all data loaded
            // show dialog
            const ref = this.dialogService.open(AddGISDialogComponent, {
              data: {
                title: 'Team',
                subTitle: '',
                CreditCards: this.CreditCards,
                SelectedCreditCard: 0,
                Bundle: this.GISSharedBundle,
                CDKey: ''
              },
              modal: false,
              maskStyleClass: 'opened',
              draggable: true,
              keepInViewport: true,
              width: '700px'
            });
            ref.onClose.subscribe(() => {
              this.RefreshProducts();
            });
            this.isBusy = false;
          })
      )
      .catch((error: HttpError) => {
        this.isBusy = false;
      });
  }

  GetCreditCards(): Promise<any> {

    if (this.CreditCards != undefined && this.CreditCards.length > 0)
      // we already have credit cards
      return new Promise<any>((resolve, reject) => { resolve(this.CreditCards); });


    // get all credit cards
    return this.api.CreditCardGetAll()
      .toPromise()
      .then(response => {

        if (!response.Result)
          return; // error

        if (response.Data.length == 0)
          return; // error

        // populate credit cards
        this.CreditCards = [];

        response.Data.forEach(card => {
          if (this.isExpired(card) && !card.IsDefault) {
            //skip this card
          }
          else {
            this.CreditCards.push(
              {
                label: 'Name: ' + card.FirstName + ' ' + card.LastName +
                  ' - Last four: ' + card.LastFour +
                  ' - exp. Date: ' + card.ExpMonth + '/' + card.ExpYear,
                value: card.ID
              }
            );
          }
        });

        return response;
      });
  }

  isExpired(Item: CreditCardResponse): boolean {
    let currentYear = new Date().getFullYear();
    let currentMonth = new Date().getMonth();
    if (Item.ExpYear + 2000 < currentYear)
      return true;
    else if (Item.ExpYear + 2000 == currentYear && Item.ExpMonth < currentMonth)
      return true

    return false;
  }

  showAddGISDialog(cdKey: string) {
    this.isBusy = true;

    // 1st get credit cards
    this.GetCreditCards()
      .then((response) =>

        // 2d get gis individual bundle
        this.GetGISIndividualBundle()
          .then((response) => {

            // all data loaded
            // show dialog
            const ref = this.dialogService.open(AddGISDialogComponent, {
              data: {
                title: 'Personal',
                subTitle: this.gb.FirstName + ' ' + this.gb.LastName,
                CreditCards: this.CreditCards,
                SelectedCreditCard: 0,
                Bundle: this.GISIndividualBundle,
                CDKey: cdKey
              },
              modal: false,
              maskStyleClass: 'opened',
              draggable: true,
              keepInViewport: true,
              width: '700px'
            });
            ref.onClose.subscribe(() => {
              this.RefreshProducts();
            });
            this.isBusy = false;
          })
      )
      .catch((error: HttpError) => {
        this.isBusy = false;
      });

  }

  private GetCancelledLicense(): Promise<DashboardLicenseResponse> {
    return new Promise((resolve, reject) => {
      let cancelledLicense;
      for (let k = 0; k < this.Products.length; k++) {
        if (this.Products[k] && this.Products[k].Licenses) {
          for (let i = 0; i < this.Products[k].Licenses.length; i++) {
            let license = this.Products[k].Licenses[i];
            if ((license.Status == LicenseStatus.Cancelled || license.Status == LicenseStatus.Terminated || license.Status == LicenseStatus.CancelledOpen) && !license.IsGrace && moment(license.NextBillingDate).isBefore(moment())) {
              cancelledLicense = license;
            }
          }
          setTimeout(() => {
            resolve(cancelledLicense);
          }, 250);
        }
      }

      setTimeout(() => {
        reject();
      }, 500);
    });
  }

  GetGISSharedBundle(): Promise<any> {

    return this.api.GISSharedBundle()
      .toPromise()
      .then(response => {
        if (!response.Result)
          return; // error

        this.GISSharedBundle = response.Data;

        return response;
      });
  }

  GetGISIndividualBundle(): Promise<any> {

    return this.api.GISIndividualBundle()
      .toPromise()
      .then(response => {

        if (!response.Result)
          return; // error

        this.GISIndividualBundle = response.Data;

        return response;
      });
  }


  GetSharedGISCredits(): number {
    if (this.Products.length == 0)
      return 0;
    else
      return this.Products[0].SharedGISCredits;

  }


  GetPersonalGISCredits(): number {
    if (this.ProductsExpanded.length == 0)
      return 0;
    else
      return this.ProductsExpanded[0].Member.PersonalGISCredits;

  }


  SortByStatus(sortThis: MemberLicenseItem[]): MemberLicenseItem[] {

    sortThis.sort((a, b) => a.License.Status - b.License.Status);

    return sortThis;
  }



  UpdateHasPastDuePayments(myProducts: MemberLicenseItem[]) {
    let hasPastDuePayments: boolean = false;

    myProducts.forEach(x => {
      if (x.License.IsGrace) {
        hasPastDuePayments = true;
      }
    });

    this.HasPastDuePayments = hasPastDuePayments;
  }

  loadEvents() {
    const subscription = this.api.MemberDesignersLicensesBasics().subscribe(res => {
      this.MyProducts = res.Data;
      const tempEvents = [];
      const request: TrainingCalendarRequest = {
        StartDate: moment().startOf('month').toDate(),
        EndDate: moment().endOf('month').toDate()
      };

      const disposable = this.api.GetMemberTrainingCalendar(request).subscribe(response => {
        response.Data['TrainingEvents'].forEach((e: TrainingEvent) => {
          const trainingClass: TrainingClass = response.Data['TrainingClasses'].filter(c => c.ID == e.TrainingClassID)[0];
          if (this.MemberHasProductForClass(trainingClass.ProductIDs)) {
            const duration = moment(trainingClass.ClassDuration, 'hh:mm:ss');
            const eventTemplate: CalendarEvent = new CalendarEvent();
            eventTemplate.title = trainingClass.ClassTitle;
            eventTemplate.start = new Date(e.EventDateTime);
            eventTemplate.end = moment(e.EventDateTime).add({ hours: duration.hours(), minutes: duration.minutes() }).toDate();
            eventTemplate.extendedProps = {
              event: e
            };
            eventTemplate.extendedProps.event.TrainingClass = trainingClass;
            tempEvents.push(eventTemplate);
          }
        });
        this.nextLiveTrainingEvent = tempEvents.find(e => moment(e.start).isAfter(moment()));
        // this.nextLiveTrainingEvent = tempEvents[tempEvents.length - 1];
        disposable.unsubscribe();
      });
    });
  }

  MemberHasProductForClass(products: Number[]): Boolean {
    let productFound = false;
    this.MyProducts.forEach((product) => {
      product.Keys.forEach((key) => {
        if (key && products.indexOf(key.Product_ID) >= 0) {
          productFound = true;
        }
      });
    });
    return productFound;
  }

  removeHTMLTags(str) {
    if ((str === null) || (str === ''))
      return false;
    else
      str = str.toString();
    return str.replace(/(<([^>]+)>)/ig, '');
  }

  getFirstSentence(str) {
    const strippedStr = this.removeHTMLTags(str);
    return strippedStr.split('.')[0] + '.';
  }

  getFirstImage(htmlStr) {
    if (!htmlStr) {
      return '';
    }
    let imgBody;
    let imgMainBody;
    let imgSrcBody;
    let imgUrl;
    imgBody = htmlStr.split('<img')[1];
    if (imgBody) {
      imgMainBody = imgBody.split('>')[0];
    }
    if (imgMainBody) {
      imgSrcBody = imgMainBody.split('src="')[1];
    }
    if (imgSrcBody) {
      imgUrl = imgSrcBody.split('"')[0];
    }

    return imgUrl;
  }

  isPast(date: string) {
    return moment(date).isBefore(new Date());
  }
}
